<div class="error-message" *ngIf="errorName || showClienteError">Complete los campos obligatorios.</div>
<div class="error-message"
    *ngIf="!errorName && !showClienteError &&(errorEmail || errorContrasenha || errorEmailNoti || errorContrasenhaIguales)">
    Hay campos
    introducidos incorrectamente.</div>
<div class="ok-message fade-out"
    *ngIf="!errorName && !errorEmail && !errorEmailNoti && !errorContrasenha && !errorContrasenhaIguales && !showClienteError && usuarioEditado && !errorFinal">
    El usuario se ha editado correctamente.</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorFinalMessage}}</div>

<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">EDITAR USUARIO DATABEER</span>
            <button mat-icon-button matTooltip="Editar usuario" class="gurdar-btn" (click)="guardarUsuario()"
                [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text font14">Formulario de edición de usuarios DataBeer</span>
    </div>
    <div class="body" *ngIf="es_estrella">
        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container">
                <mat-label class="label-text" [ngClass]="{'error-select': errorName}">Nombre y
                    Apellidos</mat-label>
                <input matInput placeholder="Introduzca el nombre de usuario" formControlName="name" required>
                <button *ngIf="nameInput?.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearField('name')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="errorName" class="costum1">El campo Nombre no puede estar vacío</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': errorEmail}">Correo
                    electrónico</mat-label>
                <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="email"
                    required>
                <button *ngIf="emailInput?.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearField('email')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="errorEmail" class="costum1">Introducizca un email válido</mat-error>
        </form>

        <form [formGroup]="signin" class="width100" *ngIf="!es_corporativo">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': errorContrasenha}">Contraseña</mat-label>
                <input matInput placeholder="Introduzca la contraseña del usuario" [type]="hide ? 'password' : 'text'"
                    formControlName="password">
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
            <mat-error *ngIf="passwordInput?.hasError('minlength') && !errorContrasenha" class="costum1">
                La contraseña debe tener al menos 4 caracteres
            </mat-error>
        </form>

        <form [formGroup]="signin" class="width100" *ngIf="!es_corporativo">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': errorContrasenhaIguales}">Repite
                    contraseña</mat-label>
                <input matInput placeholder="Repita la contraseña" [type]="hideR ? 'password' : 'text'"
                    formControlName="passwordR">
                <mat-icon matSuffix (click)="hideR = !hideR">{{hideR ? 'visibility_off' :
                    'visibility'}}</mat-icon>
            </mat-form-field>
            <mat-error *ngIf="errorContrasenhaIguales" class="costum1">
                Las contraseñas no coinciden. Asegúrate de introducir la misma contraseña</mat-error>
            <mat-error *ngIf="passwordInput?.hasError('minlength') && !errorContrasenha" class="costum1">
                La contraseña debe tener al menos 4 caracteres
            </mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': errorEmailNoti}">Correo electrónico
                    para
                    notificaciones</mat-label>
                <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="emailNoti">
                <button *ngIf="emailNotiInput?.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearField('emailNoti')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="errorEmailNoti" class="costum1">Introducizca un email válido</mat-error>
        </form>

        <div class="input-container2" *ngIf="clientes.length > 1">
            <mat-label class="label-text" [ngClass]="{'error-select': showClienteError}">Cliente*</mat-label>
            <mat-form-field class="costum2">
                <mat-label [ngClass]="{'error-select': showClienteError}">-Elige una opción-</mat-label>
                <mat-select [(value)]="selectedCliente" name="est" (selectionChange)="clienteSeleccionado()">
                    <mat-option *ngFor="let est of clientes" [value]="est.value">
                        {{est.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="showClienteError" class="cosntum3">Selecciona un cliente</mat-error>
        </div>

        <div class="input-container2 costum4" *ngIf="userDataSer.pro_id === 4">
            <div class="radio-button-container">
                <mat-checkbox [(ngModel)]="es_corporativo" >
                    Usuario corporativo
                </mat-checkbox>
            </div>
        </div>

        <div class="input-container2 costum4" *ngIf="userDataSer.pro_id != 4">
            <div class="radio-button-container">
                <mat-checkbox [(ngModel)]="es_corporativo" [class.solo-lectura]="userDataSer.pro_id !== 4" (click)="userDataSer.pro_id !== 4 && $event.preventDefault()">
                    Usuario corporativo
                </mat-checkbox>
            </div>
        </div>

        <div class="input-container2 costum4" *ngIf="es_corporativo">
            <span class="label-text marginLeft1P">Perfil de acceso global</span>
            <div class="radio-button-container">
                <mat-radio-group aria-label="Tipo de usuario" [(ngModel)]="tipoUsuario">
                    <mat-radio-button *ngIf="userDataSer.pro_id === 4" [value]="4">Super usuario
                        root</mat-radio-button>
                    <mat-radio-button [value]="1">Administrador</mat-radio-button>
                    <mat-radio-button [value]="2">Hostelero</mat-radio-button>
                    <mat-radio-button [value]="3">Consumidor</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <div class="input-container2 costum4" *ngIf="!es_corporativo">
            <span class="label-text marginLeft1P">Perfil de acceso global</span>
            <div class="radio-button-container">
                <mat-radio-group aria-label="Tipo de usuario" [(ngModel)]="tipoUsuarioRecuperacion">
                    <mat-radio-button [value]="4">Super usuario
                        root</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <ng-container *ngIf="tipoUsuario === 2">
            <div class="costum5">
                <mat-icon>store</mat-icon>&nbsp;&nbsp;<span class="fontWeight500">Establecimientos *</span>
            </div>
            <mat-form-field class="input-container2">
                <mat-label>-Establecimientos-</mat-label>
                <mat-select [(ngModel)]="selectedEstablecimiento" name="modVer" multiple>
                    <mat-checkbox [(ngModel)]="selectAllEstablecimientos" (change)="selectAllEstablecimientosChanged()"
                        color="primary" class="marginLeft5">
                        <span class="costum6">Seleccionar todos</span>
                    </mat-checkbox>
                    <mat-option *ngFor="let modVer of establecimientosCopia" [value]="modVer.establecimientoId">
                        {{modVer.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>

        <div class="input-container2 costum7">
            <span class="label-text marginLeft1P">Estado</span>
            <div class="radio-button-container">
                <mat-radio-group aria-label="Estado del cliente" [(ngModel)]="estado">
                    <mat-radio-button [value]="1">Activado</mat-radio-button>
                    <mat-radio-button [value]="0">Desactivado</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>
    <div class="body" *ngIf="!es_estrella">
        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container">
                <mat-label class="label-text" [ngClass]="{'error-select': errorName}">Nombre y
                    Apellidos</mat-label>
                <input matInput placeholder="Introduzca el nombre de usuario" formControlName="name" required>
                <button *ngIf="nameInput?.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearField('name')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="errorName" class="costum1">El campo Nombre no puede estar vacío</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': errorEmail}">Correo
                    electrónico</mat-label>
                <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="email"
                    required>
                <button *ngIf="emailInput?.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearField('email')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="errorEmail" class="costum1">Introducizca un email válido</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': errorContrasenha}">Contraseña</mat-label>
                <input matInput placeholder="Introduzca la contraseña del usuario" [type]="hide ? 'password' : 'text'"
                    formControlName="password">
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
            <mat-error *ngIf="passwordInput?.hasError('minlength') && !errorContrasenha" class="costum1">
                La contraseña debe tener al menos 4 caracteres
            </mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': errorContrasenhaIguales}">Repite
                    contraseña</mat-label>
                <input matInput placeholder="Repita la contraseña" [type]="hideR ? 'password' : 'text'"
                    formControlName="passwordR">
                <mat-icon matSuffix (click)="hideR = !hideR">{{hideR ? 'visibility_off' :
                    'visibility'}}</mat-icon>
            </mat-form-field>
            <mat-error *ngIf="errorContrasenhaIguales" class="costum1">
                Las contraseñas no coinciden. Asegúrate de introducir la misma contraseña</mat-error>
            <mat-error *ngIf="passwordInput?.hasError('minlength') && !errorContrasenha" class="costum1">
                La contraseña debe tener al menos 4 caracteres
            </mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': errorEmailNoti}">Correo electrónico
                    para
                    notificaciones</mat-label>
                <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="emailNoti">
                <button *ngIf="emailNotiInput?.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearField('emailNoti')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="errorEmailNoti" class="costum1">Introducizca un email válido</mat-error>
        </form>

        <div class="input-container2" *ngIf="clientes.length > 1">
            <mat-label class="label-text" [ngClass]="{'error-select': showClienteError}">Cliente*</mat-label>
            <mat-form-field class="costum2">
                <mat-label [ngClass]="{'error-select': showClienteError}">-Elige una opción-</mat-label>
                <mat-select [(value)]="selectedCliente" name="est" (selectionChange)="clienteSeleccionado()">
                    <mat-option *ngFor="let est of clientes" [value]="est.value">
                        {{est.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="showClienteError" class="cosntum3">Selecciona un cliente</mat-error>
        </div>

        <div class="input-container2 costum4">
            <span class="label-text marginLeft1P">Perfil de acceso global</span>
            <div class="radio-button-container">
                <mat-radio-group aria-label="Tipo de usuario" [(ngModel)]="tipoUsuario">
                    <mat-radio-button *ngIf="userDataSer.pro_id === 4" [value]="4">Super usuario
                        root</mat-radio-button>
                    <mat-radio-button [value]="1">Administrador</mat-radio-button>
                    <mat-radio-button [value]="2">Hostelero</mat-radio-button>
                    <mat-radio-button [value]="3">Consumidor</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <ng-container *ngIf="tipoUsuario === 2">
            <div class="costum5">
                <mat-icon>store</mat-icon>&nbsp;&nbsp;<span class="fontWeight500">Establecimientos *</span>
            </div>
            <mat-form-field class="input-container2">
                <mat-label>-Establecimientos-</mat-label>
                <mat-select [(ngModel)]="selectedEstablecimiento" name="modVer" multiple>
                    <mat-checkbox [(ngModel)]="selectAllEstablecimientos" (change)="selectAllEstablecimientosChanged()"
                        color="primary" class="marginLeft5">
                        <span class="costum6">Seleccionar todos</span>
                    </mat-checkbox>
                    <mat-option *ngFor="let modVer of establecimientosCopia" [value]="modVer.establecimientoId">
                        {{modVer.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>

        <div class="input-container2 costum7">
            <span class="label-text marginLeft1P">Estado</span>
            <div class="radio-button-container">
                <mat-radio-group aria-label="Estado del cliente" [(ngModel)]="estado">
                    <mat-radio-button [value]="1">Activado</mat-radio-button>
                    <mat-radio-button [value]="0">Desactivado</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>